import {colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    background: '#fff',
    padding: 10,
    minHeight: '100%',
  },
  topMsg: {
    position: 'absolute',
    top: 0,
    margin: 0,
    left: 0,
    width: '100%',
    background: colors.warn,
    fontSize: 13,
    fontWeight: 600,
    textAlign: 'center',
    padding: 8,
  },
  nctContainer: {
    borderRadius: 3,
    background: '#4d565d',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 15,
    margin: '0px 20px 5px 3px',
  },
  bulkBtns: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 15,
  },
  bulkBtn: {
    marginLeft: 5
  },
  excluded: {
    background: colors.gray,
    color: colors.offWhite
  },
  nct: {
    fontSize: '1.1rem',
    display: 'flex',
    flexWrap: 'wrap',
  },
  icon: {
    height: 15,
    width: 15,
    cursor: 'pointer',
    fill: 'white',
    color: 'white'
  },
  subIcon: {
    height: 15,
    width: 15,
    fill: 'black',
    color: 'white',
    cursor: 'pointer'
  },
  subText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    padding: 3,
    marginBottom: 10,
    marginTop: '-5px'
  },
  editPanel: {
    padding: 10,
    width: '100%',
    minHeight: '100%',
    fontSize: '1.2rem',
  },
}
